import React, { Component } from "react";

import { Col, Row } from "reactstrap";

class Dashboard extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" sm="6" lg="3">
            Dashboard
          </Col>
        </Row>
      </div>
    );
  }
}

export default Dashboard;
